export default __webpack_public_path__ + "43ef24094e07434823ff3f026a90bd77.png";